module.exports = __webpack_public_path__ + "media/Airbnb_20200825.c470870c.mp4";